import { fetchCurrentUser } from '../../ducks/user.duck';
import { getChatHistoryByRulebookIdApi } from '../../util/api';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //


export const FETCH_CHAT_LOGS_REQUEST = 'app/AdminPanelChatHistoryPage/FETCH_CHAT_LOGS_REQUEST';
export const FETCH_CHAT_LOGS_SUCCESS = 'app/AdminPanelChatHistoryPage/FETCH_CHAT_LOGS_SUCCESS';
export const FETCH_CHAT_LOGS_ERROR = 'app/AdminPanelChatHistoryPage/FETCH_CHAT_LOGS_ERROR';


// ================ Reducer ================ //

const initialState = {
  fetchChatLogsInProgress: false,
  fetchChatLogError: null,
  chatLogs: [],
  chatLogspagination: {
    currentPage: 1,
    totalPages: 1,
    totalEntries: 0,
    pageSize: 10,
  },
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CHAT_LOGS_REQUEST:
      return {
        ...state,
        fetchChatLogsInProgress: true,
        fetchChatLogError: null,
      };

    case FETCH_CHAT_LOGS_SUCCESS:
      return {
        ...state,
        fetchChatLogsInProgress: false,
        chatLogs: payload.chatHistory || [],
        chatLogspagination: payload.pagination || initialState.chatLogspagination,
      };

    case FETCH_CHAT_LOGS_ERROR:
      return {
        ...state,
        fetchChatLogsInProgress: false,
        fetchChatLogError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchChatLogsRequest = () => ({
  type: FETCH_CHAT_LOGS_REQUEST,
});

export const fetchChatLogsSuccess = (data) => ({
  type: FETCH_CHAT_LOGS_SUCCESS,
  payload: data,
});

export const fetchChatLogsError = (error) => ({
  type: FETCH_CHAT_LOGS_ERROR,
  payload: error,
});

// ================ Thunks ================ //

// chatLogActions.js (continued)
export const fetchChatLogs = (params, queryParams) => async (dispatch) => {
  dispatch(fetchChatLogsRequest());

  const { rulebookId } = params;
  const { sort_by = 'created_at', sort_order = 'desc', page = 1 } = queryParams || {};

  try {
    const response = await getChatHistoryByRulebookIdApi({
      rulebook_id: rulebookId,
      page,
      limit: 10,
      sort_by,
      sort_order,
    });

    dispatch(fetchChatLogsSuccess(response));
    return response;
  } catch (error) {
    console.error("Fetch Chat Logs Error:", error);
    dispatch(fetchChatLogsError("Failed to fetch chat logs"));
    throw error;
  }
};



export const loadData = (params, search, config) => (dispatch, getState) => {
  const queryParams = parse(search);

  return Promise.all([dispatch(fetchCurrentUser({}))])
    .then(async response => {
      const currentUser = getState().user.currentUser;
      if (currentUser?.attributes?.profile?.privateData?.isSupabaseAdmin) {
        dispatch(fetchChatLogs(params, queryParams))
      }
      return response;
    })
    .catch(e => {
      throw e;
    });
};


